// @flow
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  img: string,
  title: string,
  date: string,
  slug: string,
  categorySlug: string,
  categoryName?: string,
  className?: string,
  titleClassName?: string,
}

const NewsRow = (props: Props) => {
  return (
    <Link 
      to={`/actualites/${props.categorySlug}/${props.slug}`} 
      className={props.className !== null ? props.className : "news news--row"}
      title={`Lire la suite du contenu ${props.title}`}>
      <article>
        <div className="news__thumbnail img-blue" style={{backgroundImage: `url(${props.img})`}}>
          <img src={props.img} alt={`Illustration de ${props.title}`}/>
        </div>
        <div>
          <span className={props.titleClassName !== null ? props.titleClassName : "news__title ft-h4"}>
            {props.title}
          </span>
          <p className="ft-h6">
            {props.categoryName !== null && 
            <span className="news__cat ft-up">{props.categoryName}</span>}
            <span className="news__date">{props.date}</span>
          </p>
        </div>
      </article>
    </Link>
  );
};

export default NewsRow;
